"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_core_1 = require("@patternfly/react-core");
const OdfLvmDisksManualFormattingHint = () => {
    return (react_1.default.createElement(react_core_1.Alert, { variant: react_core_1.AlertVariant.warning, isInline: true, title: "Make sure you format all non-installation disks" }, "All non-installation disks will be used for local storage and must be formatted before the storage operator's installation."));
};
exports.default = OdfLvmDisksManualFormattingHint;
//# sourceMappingURL=OdfLvmDisksManualFormattingHint.js.map